import React, { useState } from 'react';
import { 
  FaWhatsapp, 
  FaInstagram, 
  FaPhone, 
  FaMapMarkerAlt,
  FaEnvelope // Importando o ícone de e-mail
} from 'react-icons/fa';
import './ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    nome: '',
    mensagem: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsAppNumber = '5535988179138'; 
    const messageBody = `*Contato via Site - Alzira Plaza Hotel*\n\n*Nome:* ${formData.nome}\n\n*Mensagem:*\n${formData.mensagem}`;
    const encodedMessage = encodeURIComponent(messageBody);
    const whatsappUrl = `https://wa.me/${whatsAppNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const scrollToLocation = () => {
    const locationSection = document.getElementById('localizacao');
    if (locationSection) {
      locationSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
   <section id="contato" className="section contact-section">
      <div className="container">
        <div className="contact-frame">
          <div className="section-header">
            <span className="section-eyebrow">Fale Conosco</span>
            {/* --- SECTION TITLE ATUALIZADO --- */}
            <h2 className="section-title">Sua Experiência Começa Aqui</h2>
            <p className="section-subtitle">
              Nossa equipe está pronta para auxiliar com sua reserva e garantir uma estadia memorável no coração de São Lourenço.
            </p>
          </div>

          <div className="contact-content">
            <div className="contact-info">
              <h3>Nossos Canais</h3>
              <div className="contact-method">
                <FaPhone className="icon" />
                <a href="tel:+553533312970">(35) 3331-2970</a>
              </div>
              <div className="contact-method">
                <FaWhatsapp className="icon" />
                <a href="https://wa.me/5535988179138" target="_blank" rel="noopener noreferrer">(35) 9 8817-9138</a>
              </div>
              {/* --- NOVO CANAL DE EMAIL ADICIONADO --- */}
              <div className="contact-method">
                <FaEnvelope className="icon" />
                <a href="mailto:contato@alziraplazahotel.com.br">contato@alziraplazahotel.com.br</a>
              </div>
              <div className="contact-method">
                <FaInstagram className="icon" />
                <a href="https://www.instagram.com/alziraplaza/" target="_blank" rel="noopener noreferrer">@alziraplaza</a>
              </div>
              <div className="contact-method">
                <FaMapMarkerAlt className="icon" />
                <span 
                  className="address-clickable" 
                  onClick={scrollToLocation}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && scrollToLocation()}
                >
                  Av. Dr. Getúlio Vargas, 31, Centro, São Lourenço - MG
                </span>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <h2>Envie-nos uma Mensagem</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="nome">Seu Nome</label>
                  <input type="text" id="nome" name="nome" value={formData.nome} onChange={handleChange} required placeholder="Como podemos te chamar?" />
                </div>
                <div className="form-group">
                  <label htmlFor="mensagem">Sua Mensagem</label>
                  <textarea id="mensagem" name="mensagem" value={formData.mensagem} onChange={handleChange} required placeholder="Olá, gostaria de saber mais sobre..." rows="5"></textarea>
                </div>
                <div className="form-submit-container">
                  <button type="submit" className="btn btn-primary">Enviar via WhatsApp</button>
                </div>
              </form>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
};

export default ContactSection;